import apiHelpers from '@/utils/api'
import { AxiosPromise } from 'axios'
import { AlrContainer } from '@/models/response/AlrContainer'
import { AloPositionRemarquable } from '@/models/alo/AloPositionRemarquable'
import { ApiResultCode } from '@/models/response/AlrBase'
import { AloBaseArray } from '@/models/alo/AloBaseArray'



export default {  
  getPositionRemarquables(): AxiosPromise<AlrContainer<AloBaseArray<AloPositionRemarquable>>> {
    
    return apiHelpers.apiCall({ 
      url: 'api/positionremarquable', 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return new AlrContainer<AloBaseArray<AloPositionRemarquable>>(JSON.parse(data),AloPositionRemarquable.createAloPositionRemarquableArray)
      }]
    })
  },
  getPositionRemarquable(id:number):AxiosPromise<AlrContainer<AloPositionRemarquable>> {
    return  apiHelpers.apiCall({ 
      url: `api/positionremarquable/${id}`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return new AlrContainer<AloPositionRemarquable>(JSON.parse(data),AloPositionRemarquable.createAloPositionRemarquableWithDetail)
      }]
    })
  },
  savePositionRemarquable(positionRemarquable:AloPositionRemarquable):AxiosPromise<AlrContainer<AloPositionRemarquable>> {
    if(positionRemarquable.prmId && positionRemarquable.prmId > 0) {
      return  apiHelpers.apiCall({
        url: `api/positionremarquable/${positionRemarquable.prmId}`,
        method: 'PUT',
        data: positionRemarquable,
        transformResponse: [function (data:string) {
          return new AlrContainer<AloPositionRemarquable>(JSON.parse(data),AloPositionRemarquable.createAloPositionRemarquableWithDetail)
        }]
      })
    }
    else{
      return  apiHelpers.apiCall({
        url: `api/positionremarquable`,
        method: 'POST',
        data: positionRemarquable,
        transformResponse: [function (data:string) {
          return new AlrContainer<AloPositionRemarquable>(JSON.parse(data),AloPositionRemarquable.createAloPositionRemarquableWithDetail)
        }]
      })
    }
  },
  deletePositionRemarquable(id:number):AxiosPromise<AlrContainer<AloPositionRemarquable>> {
    return  apiHelpers.apiCall({
      url: `api/positionremarquable/${id}`,
      method: 'DELETE',
      transformResponse: [function (data:string) {
        return new AlrContainer<any>(JSON.parse(data),i => i)
      }]
    })
  }
}